import { render, staticRenderFns } from "./RichEditorImages.vue?vue&type=template&id=6ddbaa7a&"
import script from "./RichEditorImages.vue?vue&type=script&lang=js&"
export * from "./RichEditorImages.vue?vue&type=script&lang=js&"
import style0 from "./RichEditorImages.vue?vue&type=style&index=0&id=6ddbaa7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports